import { Typography } from '@canvas-logic/clp-shared-ui';

import styles from './ConfiguratorError.module.css';

const getErrorMessage = (errorCode: string) => {
  if (errorCode === 'INVALID_SAVED_CONFIGURATION') {
    return 'Oops! It seems like your saved configuration is no longer accessible. Please create a new one.';
  }

  return 'Invalid configuration';
};

export const ConfiguratorError = ({ errorCode }: { errorCode: string }) => {
  return (
    <div className={styles.wrapper}>
      <Typography variant="heading3">{getErrorMessage(errorCode)}</Typography>
    </div>
  );
};
